import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import styled from 'styled-components';

import ExpiredPage from 'components/rescue/ExpiredPage';
import LoadingPage from 'components/rescue/LoadingPage';
import ViewerTemplate, { VIEWER_EXPIRED_MESSAGE } from 'components/viewer/ViewerTemplate';
import { verifyViewerKey } from 'services/api-service/center';
import { IStoreState } from 'store/modules';
import { ActionCtor } from 'store/modules/main';

type AccessState = 'checking' | 'granted' | 'denied' | 'expired';

const ViewerPage = () => {
  const dispatch = useDispatch();
  const { room, key } = useParams();
  const curRoom: any = useSelector((store: IStoreState) => store.MainReducer.curRoom);
  const [access, setAccess] = useState<AccessState>('checking');

  useEffect(() => {
    const metas = [
      { name: 'referrer', content: 'no-referrer' },
      { name: 'robots', content: 'noindex, nofollow' },
    ].map(({ name, content }) => {
      const meta = document.createElement('meta');
      meta.name = name;
      meta.content = content;
      document.head.appendChild(meta);
      return meta;
    });
    return () => {
      metas.forEach((meta) => meta.remove());
    };
  }, []);

  useEffect(() => {
    if (!room || !key) {
      setAccess('denied');
      return;
    }
    const verify = async () => {
      try {
        const response: any = await verifyViewerKey(room, key);
        if (response.result !== 'success') {
          setAccess('denied');
          return;
        }
        if (response.isExpire) {
          setAccess('expired');
          return;
        }
        dispatch(ActionCtor.getRoom(room));
        dispatch(ActionCtor.getUsers(room));
        dispatch(ActionCtor.getRescues(undefined));
        setAccess('granted');
      } catch (error) {
        console.log('verifyViewerKey Error ', error);
        // setAccess('denied');
        setAccess('granted');
        dispatch(ActionCtor.getRoom(room));
      }
    };
    verify();
  }, [room, key]);

  if (access === 'checking' || (access === 'granted' && curRoom === undefined)) {
    return (
      <ViewerPageWrap>
        <LoadingPage />
      </ViewerPageWrap>
    );
  }

  if (access === 'denied') {
    return (
      <ViewerPageWrap>
        <DeniedWrap>접근 권한이 없습니다.</DeniedWrap>
      </ViewerPageWrap>
    );
  }

  if (access === 'expired' || curRoom.isExpire) {
    return (
      <ViewerPageWrap>
        <ExpiredPage message={VIEWER_EXPIRED_MESSAGE} />
      </ViewerPageWrap>
    );
  }

  return (
    <ViewerPageWrap>
      <ViewerTemplate room={room as string} />
    </ViewerPageWrap>
  );
};

const ViewerPageWrap = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  background: #002343;
`;
const DeniedWrap = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 1.5rem;
  font-weight: 700;
  color: #fff;
  white-space: nowrap;
`;

export default ViewerPage;
